// extracted by mini-css-extract-plugin
module.exports = {"card":"GigAssist_card__SAhQs","conclusion":"GigAssist_conclusion__U94h3"};